import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, IconButton, Stack } from '@mui/material';

import Logo from 'components/Logo/Logo';
import { LanguagePicker } from 'components/Header/LanguagePicker';

import { useBoolean } from 'hooks/useBoolean';
import { HeaderContainer, HeaderWrapper } from './Header.styled';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();

    const [isLanguagePickerOpen, setLanguagePicker] = useBoolean();
    const languagePickerRef = useRef<HTMLDivElement | null>(null);

    const goBack = () => navigate(-1);

    return (
        <HeaderWrapper position="sticky">
            <HeaderContainer maxWidth="lmg">
                <Logo height="32px" fontSize="18px" />
                <Stack direction="row">
                    <Box position="relative" ref={languagePickerRef}>
                        <Button
                            style={{
                                color: '#fff',
                                fontSize: '18px',
                                minWidth: '44px',
                                fontWeight: 300,
                            }}
                            onClick={setLanguagePicker.on}
                        >
                            {i18n.language}
                        </Button>
                        {isLanguagePickerOpen && <LanguagePicker onClose={setLanguagePicker.off} />}
                    </Box>
                    <IconButton onClick={goBack} size="large" edge="end" color="inherit" sx={{ py: 0 }}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </HeaderContainer>
        </HeaderWrapper>
    );
};

export default Header;
